import { msalConfig } from "./authConfig";
import * as msal from "@azure/msal-browser";

const pca = msal.createStandardPublicClientApplication(msalConfig);

export const getMsalInstance = async () => {
    return await pca;
};
